import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Tab } from "../../../../Tab/index.js";
import { Tabs } from "../../../../Tabs/index.js";
import { tabs } from "../../utils/data.js";
const FilterTabs = ()=>{
    const [selectedTab, setSelectedTab] = useState(0);
    const onTabChange = (value)=>{
        setSelectedTab(value);
    };
    return /*#__PURE__*/ jsx(Tabs, {
        value: selectedTab,
        onTabChange: onTabChange,
        className: "tw-flex tw-justify-start tw-bg-transparent dark:tw-bg-transparent tw-mt-1.6",
        children: tabs.map(({ key, label })=>/*#__PURE__*/ jsx(Tab, {
                label: label,
                size: "s"
            }, key))
    });
};
export { FilterTabs };
